import { IMPC_EDIT_REQUEST, IMPC_EDIT_SUCCESS, IMPC_EDIT_FAILURE } from './types/ImpcEditActionTypes';

export function putImpcEditRequestActionCreator(context, newImpcCode, centralPoint) {
  return {
    type: IMPC_EDIT_REQUEST,
    payload: {
      appContext: context,
      params: {
        impcCode: newImpcCode,
        centralEntryPoint: centralPoint,
      },
    },
  };
}

export function putImpcEditSuccessActionCreator(data) {
  return {
    type: IMPC_EDIT_SUCCESS,
    payload: data,
  };
}

export function putImpcEditFailureActionCreator(error) {
  return {
    type: IMPC_EDIT_FAILURE,
    payload: error,
    error: true,
  };
}
